import React from "react";

/**
 * Shared list-table footer: items-per-page selector on the left, pagination on
 * the right. Used across the list pages (Team, Project, Client, Vendor,
 * Component, Mail, Approval, Escalation, Field configuration) so they stay
 * visually consistent.
 *
 * The pagination itself stays in each page (it needs page-specific props), so
 * this component renders the per-page control on the left and accepts the
 * <ReactPaginate/> element via `pagination` on the right.
 *
 * @param {object} props
 * @param {number} props.itemsPerPage      current page size
 * @param {(n:number)=>void} props.onItemsPerPageChange  receives the new size
 * @param {React.ReactNode} props.pagination  the <ReactPaginate/> element
 * @param {number[]} [props.options]        selectable page sizes
 */
const ListFooter = ({ itemsPerPage, onItemsPerPageChange, pagination, options = [5, 10, 20, 30, 50, 100] }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 16px",
        gap: "12px",
      }}
    >
      {/* Items per page — bottom left */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            fontFamily: "Satoshi",
            fontSize: "14px",
            fontWeight: "500",
            color: "#8790A1",
            whiteSpace: "nowrap",
          }}
        >
          Items per page
        </span>
        <select
          className="select3"
          id="perpage"
          value={itemsPerPage}
          onChange={(event) => onItemsPerPageChange(Number(event.target.value))}
          style={{
            cursor: "pointer",
            fontFamily: "Satoshi",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "18.9px",
            color: "#8790A1",
            height: "36px",
            borderRadius: "10px",
            border: "0.7px solid #E5E5E5",
            padding: "0 8px",
            backgroundColor: "#FFFFFF",
          }}
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      {/* Pagination — bottom right */}
      {pagination}
    </div>
  );
};

export default ListFooter;
